import { TypedValue } from '@multiversx/sdk-core';
import { rawVestaContract } from '.';
import { proxyNetworkProvider, resultsParser } from '..';

export const getPoolAddresses = async () => {
  const query = rawVestaContract.methods
    .getPoolAddresses()
    .check()
    .buildQuery();
  const response = await proxyNetworkProvider.queryContract(query);
  const { firstValue, returnCode } = resultsParser.parseQueryResponse(
    response,
    rawVestaContract.getEndpoint('getPoolAddresses')
  );
  if (!returnCode.isSuccess()) {
    return [];
  } else {
    return parseResult(firstValue?.valueOf() ?? []);
  }
};

const parseResult = (values: TypedValue[]) => {
  const parsed = values.map((v) => v.valueOf().bech32());
  return parsed;
};
